import { createContext, Dispatch, SetStateAction, useCallback, useContext, useEffect } from 'react';

type TabListReturn = [number, (tabId: number) => void];

export type TabListContextValue = [Record<string, number>, Dispatch<SetStateAction<Record<string, number>>>];

export const TabListContext = createContext<TabListContextValue>([{}, () => ({})]);

export function useTab(tabListId: string, initialTabId: number): TabListReturn {
  const [tabs, setTabs] = useContext(TabListContext);

  const setActiveTabId = useCallback(
    (tabId: number) => {
      setTabs((prev) => ({ ...prev, [tabListId]: tabId }));
    },
    [setTabs, tabListId]
  );

  useEffect(() => {
    setTabs((prev) => ({ ...prev, [tabListId]: initialTabId }));
  }, [initialTabId, setTabs, tabListId]);

  return tabs[tabListId] !== undefined ? [tabs[tabListId], setActiveTabId] : [0, () => {}];
}
